"use client";

import { useEffect, useState } from "react";
import { fetchAPI } from "@/utils/fetchData";
import BottomCurves from "../curves/bottomCurves";
import TabDropdown from "../ui/tabDropdown";
import NewsTab from "../news/newsTab";
import RevealElement from "../revealElement";
import ExperienceItems from "./experienceItems";
import { slugify } from "@/utils/api-helpers";
import { Experience } from "../../../global";

export default function ExperienceGrid({ data }: { data: any }) {
    console.log(data);
    const [experiences, setExperiences] = useState<Experience[]>([]);
    const [tags, setTags] = useState<string[]>([]);
    const [selectedTab, setSelectedTab] = useState("All");

    useEffect(() => {
        const fetchData = async () => {
            const timestamp = new Date().getTime();
            const res = await fetchAPI(
                `/experiences?_=${timestamp}`,
                "content",
            );

            const data: Experience[] = res.data;
            setExperiences(data);

            const tagSet = new Set(
                data.flatMap((exp) => exp.tags?.map((t) => t.trim()) ?? []),
            );
            setTags(["All", ...Array.from(tagSet)]);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const queryTab = slugify(
            new URLSearchParams(window.location.search).get("tab") || "",
        );
        const matched = tags.find((tag) => slugify(tag) === queryTab);
        if (matched) setSelectedTab(matched);
    }, [tags]);

    const handleTabChange = (tab: string) => {
        setSelectedTab(tab);
        const formatted = slugify(tab);
        const url = new URL(window.location.href);
        url.searchParams.set("tab", formatted);
        window.history.pushState({}, "", url);
    };

    return (
        <section className="bg-rainbow pb-12 md:pb-32 xl:pb-52 pt-[16.333vw] md:pt-[8.333vw] px-8 xl:px-[10.625vw]">
            <RevealElement>
                <div className="flex flex-col items-center space-y-8 overflow-visible">
                    {/* Mobile tags */}
                    <TabDropdown
                        tabs={tags}
                        selectedTab={selectedTab}
                        onTabChange={handleTabChange}
                    />

                    {/* Desktop tags */}
                    <div className="hidden lg:flex overflow-x-auto whitespace-nowrap scrollbar-hide w-full -mx-4 space-x-2 md:space-x-4 lg:justify-center">
                        {tags.map((tag) => (
                            <NewsTab
                                key={tag}
                                name={tag}
                                selectedTab={selectedTab}
                                onClick={() => handleTabChange(tag)}
                            />
                        ))}
                    </div>

                    <ExperienceItems
                        experiences={experiences}
                        selectedTag={selectedTab}
                    />
                </div>
            </RevealElement>
            <BottomCurves
                direction="left"
                color={data.experiences.waveBgColor.waveBgColor}
            />
        </section>
    );
}
